module.exports = __webpack_public_path__ + "static/media/unchecked_radio.c90e9dcf.svg";